import Head from "next/head";
import { useTranslations } from "next-intl";

type Props = {
  children: React.ReactNode;
  title: string;
};

export function Title({ children, title }: Props) {
  const t = useTranslations("common");

  return (
    <>
      <Head>
        <title>{t("page-title", { title })}</title>
      </Head>
      {children}
    </>
  );
}
